.messages {
    background-color: '#EAEAEA';
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.inputLineOffset {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    min-height: 50px;
    max-height: 220px;
    padding: 0;
    margin: 0;
    gap: 0;
}

.input {
    flex: 1;
    display: flex;
    align-items: flex-end;
    min-height: 50px;

    textarea {
        &:focus {
            border: none !important;
            border-top: 1px solid #7c7c7c !important;
        }

        outline: 0;
        background-color: transparent;
        border: none !important;
        border-top: 1px solid #e0e0e0 !important;
        padding: 10px;
        margin: 0;
        margin-left: 10px;
        width: 100%;

        font-size: 20px;
        font-family: inherit;
        line-height: 1.5;

        // Height and scroll control
        min-height: 50px;
        max-height: 220px;
        height: auto;

        overflow-y: auto;
        resize: none;

        // Scrollbar styling
        scrollbar-width: thin;
        scrollbar-color: #c0c0c0 transparent;

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #c0c0c0;
            border-radius: 3px;
        }
    }
}

.sendButton {
    width: 100px;
    min-height: 50px;
    height: 50px;
    font-family: Hanken Grotesk !important;
    font-size: 20px !important;
    font-weight: bold;
    border-radius: 0 0 20px 0 !important;
    flex-shrink: 0;
    align-self: flex-end;
    padding: 0;
    margin: 0;
}
